import { DialogProps as DialogMuiProps } from '@mui/material';

import { DialogStyled } from './Dialog.styled';

export type DialogProps = {
  onClose: () => void;
  width?: string;
} & DialogMuiProps;

export const Dialog = ({ transitionDuration = 0, ...props }: DialogProps) => {
  return <DialogStyled transitionDuration={transitionDuration} {...props} />;
};
